<template>
  <div>
    <el-table
      border
      ref="tabel"
      :data="data"
      size="mini"
      @selection-change="change"
      max-height="180px"
      v-if="Condition == '2'"
    >
      <el-table-column
        type="selection"
        v-if="!details"
        width="35"
      ></el-table-column>
      <el-table-column label="所属区域" min-width="150px" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span>{{ row.AreaName }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="商品数量范围" min-width="120px">
        <template slot-scope="{row}">
          <span>{{row.FirstQuantity}}~{{row.AfterQuantity}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="FirstFreight" label="运费" min-width="100px"/>
      <slot name="column"></slot> -->
      <el-table-column prop="FirstQuantity" label="首件数量" min-width="100px">
        <template slot-scope="{ row }">
          <span>{{ row.FirstQuantity }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="FirstFreight" label="首件运费" min-width="100px" />
      <el-table-column
        prop="AfterQuantity"
        label="继件数量"
        min-width="100px"
      />
      <el-table-column prop="AfterFreight" label="继件运费" min-width="100px" />
      <slot name="column"></slot>
    </el-table>

    <el-table
      border
      ref="tabel"
      :data="data"
      size="mini"
      @selection-change="change"
      max-height="180px"
      v-if="Condition == '1'"
    >
      <el-table-column
        type="selection"
        v-if="!details"
        width="35"
      ></el-table-column>
      <el-table-column label="所属区域" min-width="150px" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span>{{ row.AreaName }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="商品金额范围" min-width="120px">
        <template slot-scope="{row}">
          <span>{{row.FirstAmount}}~{{row.AfterAmount}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="AmountFreight" label="金额" min-width="100px"/>
      <slot name="column"></slot> -->
      <el-table-column prop="FirstWeight" label="首件重量" min-width="100px">
        <template slot-scope="{ row }">
          <span>{{ row.FirstWeight }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="FirstFreight" label="首件运费" min-width="100px" />
      <el-table-column prop="AfterWeight" label="继件重量" min-width="100px" />
      <el-table-column prop="AfterFreight" label="继件运费" min-width="100px" />
      <slot name="column"></slot>
    </el-table>
    <add-dialog
      ref="addDialog"
      in-dialog
      @detail-save="onAddSave"
      :Condition="Condition"
    />
    <edit-dialog
      ref="editDialog"
      in-dialog
      @detail-save="onEditSave"
      :Condition="Condition"
    />
  </div>
</template>
<script>
import addDialog from "./addDialog";
import editDialog from "./editDialog";
export default {
  components: { addDialog, editDialog },
  props: {
    details: {
      type: Boolean,
      default: false,
    },
    Condition: {
      type: String,
      default: "0",
    },
    DeliveryRange: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      api: require("@/api/sale/freightSupport").default,
      // FreightId: null,
      data: [],
      select: [],
      tableDel: [],
    };
  },
  watch: {
    Condition() {},
  },
  computed: {},
  methods: {
    // setData(FreightId) {
    //   this.api.list({ FreightId, FreightType: 1 }).then((res) => {
    //     this.data = res.Data.map((x, i) => {
    //       return { ...x, Index: i };
    //     });
    //   });
    // },
    setData(data) {
      console.log(this.Condition, "Condition");
      console.log(data, "innercity");
      if (data.Weights.length > 0) {
        this.data = [];
        this.data = data.Weights;
      } else if (data.Counts.length > 0) {
        this.data = [];
        this.data = data.Counts;
      } else {
        this.data = [];
      }
      this.data = this.data.filter(
        (x) => x.DeliveryRange == this.DeliveryRange
      );
      if (this.data) {
        this.data.forEach((x, index) => {
          x.T = 3;
          x.Index = index;
        });
      }
    },

    change(rows) {
      this.select = rows;
    },
    add(data) {
      this.$refs.addDialog.openCreate(data);
    },
    onAddSave(data) {
      console.log(data, "innercity");
      data.forEach((x) => this.data.push(x));
      this.data.forEach((x, i) => (x.Index = i));
      this.$emit("detail-save", this.data);
    },
    edit(row) {
      if (this.select.length == 0) {
        this.$message.warning("请选择数据");
        return;
      }

      this.$refs.editDialog.open().then((that) => {
        that.setData(this.select);
      });
    },
    onEditSave(data) {
      data.forEach((x) => {
        var item = this.data.find((s) => s.Index == x.Index);
        item.FirstQuantity = x.FirstQuantity; //异地：首件；本地：范围
        item.FirstFreight = x.FirstFreight; //异地：首件运费；本地：运费
        item.AfterQuantity = x.AfterQuantity; //异地：继件；本地：范围
        item.AfterFreight = x.AfterFreight; //异地：继件运费
        item.FirstWeight = x.FirstWeight; //金额范围
        item.AfterWeight = x.AfterWeight; //金额范围
        item.AmountFreight = x.AmountFreight; //金额范围内运费
        item.T = x.T;
      });
    },
    del(row, index) {
      if (this.select.length == 0) {
        this.$message.warning("请选择数据");
        return;
      }
      var config = {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      };
      this.$confirm("确认删除吗？", "提示", config)
        .then(() => {
          var data = this.data;
          this.select.forEach((e) => {
            if (e.RecordId > 0) {
              this.tableDel.push({ ...e, T: 2 });
              data = data.filter((x) => x.RecordId != e.RecordId);
            } else {
              var i = data.findIndex((x) => x.Index == e.Index);
              data.splice(i, 1);
            }
          });
          this.data = data.map((x, i) => {
            return { ...x, Index: i };
          });
          // var ids = this.select.map((x) => x.SupportId);
          // this.data.forEach((e,i)=>{
          //    if(ids.some(v=>v==e.SupportId)){
          //     //  console.log(e,i)
          //         if (e.T !== 0) {
          //           e.T = 2;
          //           this.tableDel.push(e);
          //         }
          //         this.data.splice(i, 1);
          //    }
          // })
          // var ids = this.select.map((x) => x.SupportId);
          // this.api.delete({ ids }).then((res) => {
          //   if (res.Code == 0) {
          //     this.$message.success(res.Msg);
          //     this.data = this.data.filter(
          //       (x) => !ids.some((d) => d == x.SupportId)
          //     );
          //   } else {
          //     this.$message.error(res.Msg);
          //   }
          // });
        })
        .catch(() => {});
    },
  },
};
</script>